<template>
  <div class="warrantDialog">
    <el-dialog
      title="编辑"
      :visible.sync="dialogFormVisible"
      :close-on-click-modal="false"
      :append-to-body="true"
      @open="open"
      :before-close="closeForm"
    >
      <el-form :model="ruleForm" ref="ruleForm" :rules="rules" label-width="120px">
        <el-row>
          <el-row>
            <el-form-item label="机构名称" prop="orgName">
              <el-input
                v-model="ruleForm.orgName"
                :disabled="isApprovalStatus"
                placeholder="请输入机构名称"
              ></el-input>
            </el-form-item>
          </el-row>
          <el-row>
            <el-form-item label="机构简称" prop="orgAbbreviation">
              <el-input
                v-model="ruleForm.orgAbbreviation"
                :disabled="isApprovalStatus"
                placeholder="请输入机构简称"
              ></el-input>
            </el-form-item>
          </el-row>
          <el-row>
            <el-form-item label="成立时间" prop="orgEstablishmentDate">
              <el-date-picker
                style="width: 100%"
                :disabled="isApprovalStatus"
                v-model="ruleForm.orgEstablishmentDate"
                format="yyyy-MM-dd"
                value-format="yyyy-MM-dd"
                type="date"
                placeholder="选择日期"
              ></el-date-picker>
            </el-form-item>
          </el-row>
          <el-row>
            <el-form-item label="机构地址" prop="orgProvince">
              <!-- 三联 -->
              <v-distpicker
                style="text-align:left;"
                @selected="citySelected"
                :disabled="isApprovalStatus"
                :province="ruleForm.orgProvince"
                :city="ruleForm.orgCity"
                :area="ruleForm.orgDistrict"
              ></v-distpicker>
            </el-form-item>
            <el-form-item prop="orgAddress">
              <el-input
                v-model="ruleForm.orgAddress"
                :disabled="isApprovalStatus"
                placeholder="请填写详细地址"
              ></el-input>
            </el-form-item>
          </el-row>
          <!-- <el-row>
            <el-form-item label="机构性质" prop="orgType">
              <el-select
                style="width: 100%"
                v-model="ruleForm.orgType"
                @change="orgChange"
                :disabled="isApprovalStatus"
                placeholder="请选择"
              >
                <el-option
                  v-for="item in orgTypeList"
                  :key="item.id"
                  :value="item.id"
                  :label="item.label"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-row> -->
          <el-row>
            <el-form-item label="机构简介" prop="orgDescription">
              <el-input
                type="textarea"
                :autosize="{ minRows: 2, maxRows: 4 }"
                placeholder="请输入备注"
                :disabled="isApprovalStatus"
                v-model="ruleForm.orgDescription"
              ></el-input>
            </el-form-item>
          </el-row>
          <el-row>
            <el-form-item label="联系人" prop="contactPerson">
              <el-input
                v-model="ruleForm.contactPerson"
                :disabled="isApprovalStatus"
                placeholder="请输入联系人"
              ></el-input>
            </el-form-item>
          </el-row>
          <el-row>
            <el-form-item label="联系方式" prop="contactInfo">
              <el-input
                v-model="ruleForm.contactInfo"
                :disabled="isApprovalStatus"
                placeholder="请输入联系方式"
              ></el-input>
            </el-form-item>
          </el-row>
          <el-row>
            <el-form-item label="logo" prop="logoSrc">
              <el-upload
                class="avatar-uploader"
                :action="this.uploadURL"
                list-type="picture-card"
                name="file"
                :file-list="logoSrc"
                :disabled="isApprovalStatus"
                :before-upload="beforeAvatarUpload"
                :limit="limit"
                ref="upload0"
                :on-success="
                  (response, file, fileList) =>
                    handleAvatarSuccess(response, file, fileList, 'logoSrc')
                "
              >
                <i slot="default" class="el-icon-plus"></i>
                <div slot="file" slot-scope="{ file }">
                  <img class="el-upload-list__item-thumbnail" :src="file.url" alt="" />
                  <span class="el-upload-list__item-actions">
                    <span
                      class="el-upload-list__item-preview"
                      @click="handlePictureCardPreview(file)"
                    >
                      <i class="el-icon-zoom-in"></i>
                    </span>
                    <span
                      v-if="!isApprovalStatus"
                      class="el-upload-list__item-delete"
                      @click="handleRemove(file, 'logoSrc')"
                    >
                      <i class="el-icon-delete"></i>
                    </span>
                  </span>
                </div>
                <div slot="tip" class="el-upload__tip" v-if="showUpload">
                  只允许上传一张图片
                </div>
              </el-upload>
            </el-form-item>
          </el-row>
          <el-row>
            <el-form-item label="发布" prop="publishedFlag">
              <el-switch
                v-model="ruleForm.publishedFlag"
                :active-value="1"
                :inactive-value="0"
                active-text="是"
                :disabled="isApprovalStatus"
                inactive-text="否"
              ></el-switch>
            </el-form-item>
          </el-row>
          <el-form-item label="审批状态" prop="approvalStatus" style="text-align:left">
            <el-select
              v-model="ruleForm.approvalStatus"
              placeholder="请选择审核状态"
              style="display: block;"
            >
              <el-option label="待审核" :value="1"></el-option>
              <el-option label="不通过" :value="2"></el-option>
              <el-option label="退回" :value="3"></el-option>
              <el-option label="通过" :value="4"></el-option>
            </el-select>
          </el-form-item>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="closeForm">取 消</el-button>
        <el-button type="primary" @click="updateSubmitForm('ruleForm')">
          修 改
        </el-button>
      </div>
    </el-dialog>
    <el-dialog :close-on-click-modal="false" :append-to-body="true" :visible.sync="dialogVisible">
      <img width="100%" :src="dialogImageUrl" alt="" />
    </el-dialog>
  </div>
</template>

<script>
import commonUpload from '@/components/common-upload.vue';
export default {
  props: ['dialogFormVisible', 'queryId'],
  components: {
    commonUpload
  },
  data() {
    return {
      dialogImageUrl: '',
      dialogVisible: false,
      logoSrc: [],
      showUpload: false,
      orgTypeList: [],
      ruleForm: {
        dataType: 3,
        orgName: '',
        orgAbbreviation: '',
        orgEstablishmentDate: '',
        orgProvince: '',
        orgCity: '',
        orgDistrict: '',
        orgAddress: '',
        orgType: '',
        orgTypeName: '',
        orgDescription: '',
        contactInfo: '',
        logoSrc: '',
        publishedFlag: 0,
        approvalStatus: 1
      },
      limit: 1,
      rules: {
        publishedFlag: [{ required: true, message: '请选择是否发布', trigger: 'change' }],
        orgProvince: [{ required: true, message: '请选择机构地址-省', trigger: 'change' }],
        orgCity: [{ required: true, message: '请选择机构地址-市', trigger: 'change' }],
        orgDistrict: [{ required: true, message: '请选择机构地址-区', trigger: 'change' }],
        orgDescription: [{ required: true, message: '请输入机构简称', trigger: 'blur' }],
        orgName: [{ required: true, message: '请输入众创空间名称', trigger: 'blur' }],
        orgEstablishmentDate: [{ required: true, message: '请选择成立时间', trigger: 'change' }],
        orgAddress: [{ required: true, message: '请输入详细地址', trigger: 'blur' }],
        orgType: [{ required: true, message: '请选择机构性质', trigger: 'change' }],
        contactPerson: [{ required: true, message: '请输入联系人', trigger: 'blur' }],
        contactInfo: [{ required: true, message: '请输入联系方式', trigger: 'blur' }],
        logoSrc: [{ required: true, message: '请上传logo', trigger: 'changer' }],
        orgAbbreviation: [{ required: true, message: '请输入机构简称', trigger: 'blur' }],
        approvalStatus: [{ required: true, message: '请选择审批状态', trigger: ['blur', 'change'] }]
      }
    };
  },
  computed: {
    isApprovalStatus() {
      return this.ruleForm.approvalStatus === 4;
    }
  },
  watch: {
    // 监听初始时图片列表长度, 与limit相等则隐藏按钮
    logoSrc: {
      handler() {
        this.checkLimit(this.logoSrc, 0);
      }
    }
  },
  methods: {
    async open() {
      this.getSiftList('financial_institution_category');

      this.ruleForm = {
        dataType: 3,
        orgName: '',
        orgAbbreviation: '',
        orgEstablishmentDate: '',
        orgProvince: '',
        orgCity: '',
        orgDistrict: '',
        orgAddress: '',
        orgType: '',
        orgTypeName: '',
        orgDescription: '',
        contactInfo: '',
        logoSrc: '',
        publishedFlag: 0,
        approvalStatus: 1
      };
      this.getDetail();
    },
    checkLimit(filelist, index) {
      const limit = this.limit;
      const uploadDom = this.$refs['upload' + index];
      if (filelist.length === limit) {
        uploadDom.$children[1].$el.style.display = 'none';
        this.showUpload = true;
      } else {
        uploadDom.$children[1].$el.style.display = '';
        this.showUpload = false;
      }
    },
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    handleAvatarSuccess(response, file, fileList, type) {
      if (response.code == 0) {
        this[type] = fileList;
        console.log(this.ruleForm.logoSrc);
        this.fileListChange(type);
      }
    },
    fileListChange(type) {
      let arr = [];
      if (this[type].length > 0) {
        this[type].map(item => {
          arr.push({
            url: item.size ? this.imgUrl + item.response.data.store_result : item.url,
            name: item.name
          });
        });
        this.ruleForm[type] = JSON.stringify(arr);

        console.log('  this.ruleForm[type]', this.ruleForm[type]);
      } else {
        this.ruleForm[type] = '';
        this[type] = [];
      }
    },
    beforeAvatarUpload(file) {
      let type = false;
      if (
        file.type === 'image/jpeg' ||
        file.type === 'image/png' ||
        file.type === 'image/jpg' ||
        file.type === 'image/gif' ||
        file.type === 'image/bmp'
      ) {
        type = true;
      }

      var img = new Image();
      img.src = this.image;
      img.onload = function() {};

      const isLt2M = file.size / 1024 / 1024 < 10;
      if (!type) {
        this.$message.error('上传图片只能是 JPEG/jpg/png/gif/bmp 格式!');
      }
      if (!isLt2M) {
        this.$message.error('上传图片大小不能超过 10MB!');
      }
      return type && isLt2M;
    },
    orgChange(id) {
      const data = this.orgTypeList.find(item => item.id === id);
      this.ruleForm.orgTypeName = data.label;
    },
    handleRemove(file, type) {
      this.$confirm('确定删除图片吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        center: true
      })
        .then(() => {
          for (var i = 0; i < this[type].length; i++) {
            if (file.uid == this[type][i].uid) {
              this[type].splice(i, 1);
            }
          }
          console.log(this[type]);
          this.fileListChange(type);

          this.$message({
            type: 'success',
            message: '删除成功!'
          });
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          });
        });
    },
    //城市选择
    citySelected(e) {
      console.log(e, 'e');
      if (e.province.value) {
        this.ruleForm.orgProvince = e.province.value;
      }
      if (e.city.value) {
        this.ruleForm.orgCity = e.city.value;
      }
      if (e.area.value) {
        this.ruleForm.orgDistrict = e.area.value;
      }
    },
    beforeAvatarUpload(file) {
      let type = false;
      if (
        file.type === 'image/jpeg' ||
        file.type === 'image/png' ||
        file.type === 'image/jpg' ||
        file.type === 'image/gif' ||
        file.type === 'image/bmp'
      ) {
        type = true;
      }

      const isLt2M = file.size / 1024 / 1024 < 50;
      if (!type) {
        this.$message.error('上传图片只能是 JPEG/jpg/png/gif/bmp 格式!');
      }
      if (!isLt2M) {
        this.$message.error('上传图片大小不能超过 50MB!');
      }
      return type && isLt2M;
    },
    // 人才类别和从事技术领域
    getSiftList(type) {
      this.http
        .post(`${this.urlConfig.devUrl}apij2/admin-api/system/dict-data/getGroup`, {
          dictTypes: [type]
        })
        .then(res => {
          if (res.code === 0) {
            const { financial_institution_category } = res.data;
            this.orgTypeList = [...financial_institution_category];
          }
        });
    },
    async getDetail() {
      try {
        const res = await this.http.get(
          `${this.urlConfig.devUrl}apij2/admin-api/finance/investment-firms/get?id=${this.queryId}`
        );
        console.log(res, 'res');
        if (res.code === 0) {
          this.ruleForm = res.data;

          this.logoSrc = res.data.logoSrc ? JSON.parse(res.data.logoSrc) : [];
        } else {
          this.ruleForm = {
            dataType: 3,
            orgName: '',
            orgAbbreviation: '',
            orgEstablishmentDate: '',
            orgProvince: '',
            orgCity: '',
            orgDistrict: '',
            orgAddress: '',
            orgType: '',
            orgTypeName: '',
            orgDescription: '',
            contactInfo: '',
            logoSrc: '',
            publishedFlag: 0,
            approvalStatus: 1
          };
        }
      } catch (e) {
        console.log(e);
      }
    },
    updateSubmitForm(name) {
      this.$refs[name].validate(valid => {
        if (valid) {
          // 编辑提交
          this.editData();
        } else {
          return false;
        }
      });
    },
    closeForm() {
      this.$emit('close', false);
    },
    editData() {
      this.http
        .post(`${this.urlConfig.devUrl}apij2/admin-api/finance/investment-firms/update`, {
          ...this.ruleForm,
          dataType: 3
        })
        .then(res => {
          if (res.code === 0) {
            this.$emit('close', true);
            this.$message.success('编辑成功');
          } else {
            this.$messgae.error('编辑失败');
          }
        })
        .catch(e => {
          this.$messgae.error('编辑失败');
        });
    }
  }
};
</script>

<style lang="scss" scoped>
.warrantDialog {
  .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .preview_btn {
    position: absolute;
    width: 100%;
    height: 100%;
    left: 0;
    top: 0;
    background: rgba(#000, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
    i {
      cursor: pointer;
      font-size: 26px;
    }
  }

  .avatar-uploader .el-upload:hover {
    border-color: #409eff;
  }

  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 130px;
    line-height: 130px;
    text-align: center;
  }

  .avatar {
    width: 178px;
    height: 178px;
    display: block;
  }

  .el-radio-group {
    display: flex;
  }

  .upload_btn {
    display: block;
    background-color: #00a1ff;
    font-weight: bold;
    color: #fff;
    padding: 2px;
    border-bottom-left-radius: 3px;
    border-bottom-right-radius: 3px;
  }
  .upload_btn:hover {
    background-color: #13ce66;
  }

  .del_img {
    position: absolute;
    top: -7px;
    left: 224px;
    color: #00a1ff;
  }

  .del_img:hover {
    cursor: pointer;
    color: #f00;
  }

  .del_img i:before {
    font-size: 20px;
  }
  .img_border {
    border-top-left-radius: 3px;
    border-top-right-radius: 3px;
    width: 243px;
    height: 154px;
    display: block;
  }
  .el-radio {
    display: flex;
    align-items: center;
  }

  .imgInput {
    background: url(../../../../assets/add.png) no-repeat;
    border: none;
    text-indent: -2000px;
    height: 120px;
    padding: 10px;
    background-size: 70%;
    background-position: center;
    color: white;
    cursor: pointer;
  }

  .imgInput:focus {
    border: none;
    outline: 0;
  }

  .allPics {
    border: 1px solid #ccc;
    padding: 18px 15px 10px 20px;
    width: 90%;
    margin: 0 auto;
    margin-bottom: 30px;
    position: relative;
    // display: flex;
    // flex-wrap: wrap;
    // justify-content: space-between;
  }

  .allPics1 {
    display: flex;
    // flex-wrap: wrap;
  }

  .addPic-body {
    padding: 10px;
    height: 120px;
  }

  .addPic-close {
    position: absolute;
    top: 10px;
    right: 10px;
  }

  .addPic {
    max-width: 100%;
    max-height: 100%;
  }

  .el-form-item__content {
    text-align: left;
  }
  .form-title {
    width: 100%;
    text-align: left;
    color: #623aa2;
    border-left: 5px solid #623aa2;
    border-bottom: 1px solid #623aa2;
    padding-left: 10px;
    font-size: 20px;
    margin-bottom: 20px;
    font-weight: 700;
  }
}
/*上传图片*/
.is_border {
  border: 1px dashed #ddd !important;
  border-radius: 5px;
  height: 154px !important;
  line-height: 154px !important;
}

.upload_btn {
  display: block;
  background-color: #00a1ff;
  font-weight: bold;
  color: #fff;
  padding: 2px;
  border-bottom-left-radius: 3px;
  border-bottom-right-radius: 3px;
}

.upload_btn:hover {
  background-color: #13ce66;
}

.del_img {
  position: absolute;
  top: -7px;
  left: 224px;
  color: #00a1ff;
}

.del_img:hover {
  cursor: pointer;
  color: #f00;
}

.del_img i:before {
  font-size: 20px;
}

.img_border {
  border-top-left-radius: 3px;
  border-top-right-radius: 3px;
  width: 243px;
  height: 154px;
  display: block;
}

/deep/ .el-upload {
  border: 1px dashed #d9d9d9 !important;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

/deep/ .el-upload:hover {
  border-color: #409eff !important;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 243px;
  height: 154px;
  line-height: 154px;
  text-align: center;
}

/deep/ .upload-demo {
  margin-top: 10px;
  /deep/.el-upload {
    /deep/.el-button {
      font-size: 14px;
      font-family: Alibaba PuHuiTi;
      font-weight: 400;
      color: rgba(255, 255, 255, 1);
      background: rgba(66, 141, 255, 1);
      border-radius: 18px;
      padding: 10px 25px;
    }
  }
}
</style>
